<template>
    <div class="modal-content" v-if="$store.state.isShowBookmarkDialog">
      <div class="icon">
          <img src="@/assets/bookMark/icon.png" class="line" />
      </div>
      <div class="text">
          <span>{{$t("bookMark.tips1") }}</span>
      </div>

      <div class="btn-wrap">
        <div class="o-btn" @click="handleOk">
          {{ $t("bookMark.btn")  }}
        </div>
      </div>
      <div class="close">
        <!-- 关闭按钮 -->
        <img src="@/assets/login/close.png"  @click="handleClose" />
      </div>
    </div>
</template>

<script>

export default {
  props: {
  },
  name: "bookMarkLabel",
  data() {
    return {
      confirmLoading: false,
    };
  },
  methods: {
    handleOk() {
      this.$emit("onDownload");
      // this.handleClose();
    },
    handleClose() {
      this.$store.state.isShowBookmarkDialog = false;
    },
  },
};
</script>

<style lang="less" scoped>
@media only screen and (max-width: @screen-width4) {
  @import "./h5.less";
}
</style>
